<template>
  <div class="info-box static">
    <div class="flex-1 overflow-hidden gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto px-2.5"
      >
        <el-form-item label="状态" v-if="props.id">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input
            v-model="state.model.description"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  adminRole_detail,
  adminRole_add,
  adminRole_edit,
} from "@/http/adminRole";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
      sjqx: [],
    });
    onMounted(() => {
      if (props.id) {
        adminRole_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;
            state.model = data;
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            adminRole_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            adminRole_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
